import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'


Vue.use(Vuex);

const store = () => new Vuex.Store({
  state: {
    isLoading: false,
    currentErrorMessage: null,
    currentErrorLevel: 'error',
    currentErrorDescr: null,
    orderCode: null,
    address: null,
    isPickup: false,
    notes: null,
    name: null,
    waitingForPaymentCounter: 0,
    waitingForPaymentInterval: null,
    orderErrorButtonCaption: null,
    selectedProducts: [],
    selfService: {
      paymentLink: null,
      shopCode: null,
      table: null,
      origin: null,
      timestamp: null,
      waiter: null
    }
  },
  getters: {
    getTable: state => state.selfService.table,
    getCartTimestamp: state => state.selfService.timestamp,
    getWaiter: state => state.selfService.waiter,
    getPaymentLink: state => state.selfService.paymentLink,
    getOrderCode: state => state.orderCode,
    getAddress: state => state.address,
    getIsPickup: state => state.isPickup,
    getNotes: state => state.notes,
    getCustomerName: state => state.name,
    getIsLoading: state => state.isLoading,
    getWaitingForPaymentInterval: state => state.waitingForPaymentInterval,
    getWaitingForPaymentCounter: state => state.waitingForPaymentCounter,
    getOrderErrorButtonCaption: state => state.orderErrorButtonCaption,
    getCurrentErrorMessage: state => state.currentErrorMessage,
    getSelectedProducts: state => state.selectedProducts,
    getCurrentErrorDescr: state => state.currentErrorDescr,
    getCurrentErrorLevel: state => state.currentErrorLevel,
    getSelfServiceShopCode: state => state.selfService.shopCode,
    getSelfServiceQueryString: state => { return `c=${state.selfService.shopCode}&o=${state.selfService.origin}&t=${state.selfService.table}`}
  },
  mutations: {
    RESET_STATE: function (state) {
      state.isLoading = false;
      state.currentErrorMessage= null;
      state.waitingForPaymentInterval = null;
      state.waitingForPaymentCounter = null;
      state.currentErrorLevel = 'error';
      state.currentErrorDescr = null;
      state.orderCode = null;
      state.address = null;
      state.isPickup = false;
      state.notes = null;
      state.name = null;
      state.orderErrorButtonCaption = null;
      state.selectedProducts = [];
      state.selfService.origin = null;
      state.selfService.shopCode = null;
      state.selfService.table = null;
      state.selfService.timestamp = null;
      state.selfService.waiter = null;
      state.selfService.paymentLink = null;

    },
    SET_SELF_SERVICE_SHOP_CODE: function (state, shopCode) {
      state.selfService.shopCode = shopCode;
    },
    SET_SELF_SERVICE_PAYMENT_LINK: function (state, paymentLink) {
      state.selfService.paymentLink = paymentLink;
    },
    SET_SELF_SERVICE_ORIGIN: function (state, origin) {
      state.selfService.origin = origin;
    },
    SET_SELF_SERVICE_TABLE: function (state, table) {
      state.selfService.table = table;
    },
    SET_CART_TIMESTAMP: function (state, timestamp) {
      state.selfService.timestamp = timestamp;
    },
    SET_SELF_SERVICE_WAITER: function (state, waiter) {
      state.selfService.waiter = waiter;
    },
    SET_ORDER_CODE: function (state, orderCode) {
      state.orderCode = orderCode;
    },
    SET_ORDER_ADDRESS: function (state, address) {
      state.address = address;
    },
    SET_ORDER_NOTES: function (state, notes) {
      state.notes = notes;
    },
    SET_ORDER_CUSTOMER_NAME: function (state, name) {
      state.name = name;
    },
    SET_ORDER_IS_PICKUP: function (state, isPickup) {
      state.isPickup = isPickup;
    },
    SET_SELECTED_PRODUCTS: function (state, selectedProducts) {
      state.selectedProducts = selectedProducts;
    },
    SET_IS_LOADING: function (state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_CURRENT_ERROR_MESSAGE: function (state, currentErrorMessage) {
      state.currentErrorMessage = currentErrorMessage;
    },
    SET_CURRENT_ERROR_LEVEL: function (state, currentErrorLevel) {
      state.currentErrorLevel = currentErrorLevel;
    },
    SET_CURRENT_ERROR_DESCR: function (state, currentErrorDescr) {
      state.currentErrorDescr = currentErrorDescr;
    },
    SET_WAITING_FOR_PAYMENT_INTERVAL: function (state, waitingForPaymentInterval) {
      state.waitingForPaymentInterval = waitingForPaymentInterval;
    },
    SET_WAITING_FOR_PAYMENT_COUNTER: function (state, waitingForPaymentCounter) {
      state.waitingForPaymentCounter = waitingForPaymentCounter;
    },
    SET_ORDER_ERROR_BUTTON_CAPTION: function (state, orderErrorButtonCaption) {
      state.orderErrorButtonCaption = orderErrorButtonCaption;
    }
  },
  plugins: [createPersistedState()]
});

export default store



// WEBPACK FOOTER //
// ./src/store.js